"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MobileView = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "mobile-view", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "mobile-view", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M22.429 1.014 9.57 1C8.157 1 7 2.227 7 3.727v24.546C7 29.773 8.157 31 9.571 31H22.43C23.843 31 25 29.773 25 28.273V3.727c0-1.5-1.157-2.713-2.571-2.713Zm0 27.259H9.57V3.727h2.572v1.728a1 1 0 0 0 1 1h5.714a1 1 0 0 0 1-1V3.727h2.572v24.546Z", fill: "#172344" }) })) })));
};
exports.MobileView = MobileView;
